import { AntDesign } from "@expo/vector-icons";
import { Badge, Text } from "@towersystems/roam-common-native";
import { StockCount } from "@towersystems/roam-common/lib/generated-types";
import { Pressable } from "react-native";
import { Colors, Spacings, View } from "react-native-ui-lib";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";
import { statusToCompletionStatus } from "../../../../utilities/stock-count";
import { StatusBadge } from "../StatusBadge";

export interface StockCountListItemProps {
  item: StockCount;
  onPress?: (item: StockCount) => void;
}

export function StockCountListItem({ item, onPress }: StockCountListItemProps) {
  const completionStatus = statusToCompletionStatus(item.status);

  const handleOnPress = () => {
    onPress?.(item);
  };
  return (
    <Pressable onPress={handleOnPress}>
      <View
        flex
        row
        style={{
          justifyContent: "space-between",
          paddingTop: Spacings.s4,
          paddingBottom: Spacings.s4,
        }}
      >
        <View>
          <View row centerV>
            <Text variant="heading1" fontWeight="medium">
              {item.name}
            </Text>
            <View style={{ marginLeft: Spacings.s3 }}>
              <Badge
                countSource={
                  item.source === "INTERNAL" ? "SOURCE_ROAM" : "SOURCE_RETAILER"
                }
              />
            </View>
          </View>
          {item.location?.name ? (
            <Text variant="heading4" color="subdued">
              {`${formatDateToCalendar(item.createdAt)}, at ${
                item.location.name
              }`}
            </Text>
          ) : (
            <Text variant="heading4" color="subdued">
              {`${formatDateToCalendar(item.createdAt)}`}
            </Text>
          )}
        </View>
        <View style={{ alignItems: "flex-end" }}>
          <View row style={{ alignItems: "center" }}>
            <View style={{ alignItems: "flex-end" }}>
              <View row>
                <StatusBadge
                  style={{ marginLeft: Spacings.s2 }}
                  status={completionStatus}
                >
                  {completionStatus}
                </StatusBadge>
              </View>
            </View>
            <View>
              <Text fontWeight="bold" variant="heading1">
                <AntDesign
                  style={{ marginLeft: Spacings.s4, color: Colors.Text }}
                  name="right"
                  size={24}
                />
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Pressable>
  );
}
